import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

/**
 * State that lives in a URL query param, so it survives a refresh, a back-navigation and sharing
 * the link. Changing it replaces the current history entry (it doesn't stack up Back steps) and
 * leaves every other query param alone. Unknown or missing values fall back to `defaultValue`.
 */
export default function useUrlParamState(param, defaultValue, validValues) {
    const history = useHistory();
    const location = useLocation();

    const raw = new URLSearchParams(location.search).get(param);
    const value = raw !== null && (!validValues || validValues.map(String).includes(raw)) ? raw : String(defaultValue);

    const setValue = useCallback(
        (next) => {
            const params = new URLSearchParams(window.location.search);
            if (String(next) === String(defaultValue)) {
                params.delete(param);
            } else {
                params.set(param, String(next));
            }
            const search = params.toString();
            history.replace({ pathname: window.location.pathname, search: search ? `?${search}` : "", state: history.location.state });
        },
        [history, param, defaultValue],
    );

    return [value, setValue];
}
